import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ButtonGroupLayout, ContentLayout } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const CadastreOfRealEstateItemsSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<div className="p-(--spacing-l)">
			<GovSkeleton
				width={generateRandomNumber(20, 60) + '%'}
				height="30px"
				aria-label={t('loading.wcag.processing', {
					namespace: LocalizeNameSpaceTypes.Global,
				})}
			/>
			<div className="flex flex-col items-start gap-4 pt-4 [ sm:flex-row sm:items-center ]">
				<div className="flex flex-wrap gap-2">
					<GovSkeleton
						width="80px"
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="40px"
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="40px"
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="80px"
						height="20px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</div>
		</div>
	);
};

export const CadastreOfRealEstateSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<ContentLayout>
			<div className="pb-(--templates-margin-l) border-b border-(--border-subtlest)">
				<GovSkeleton
					width="320px"
					height="40px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<CadastreOfRealEstateItemsSkeleton />
			<ButtonGroupLayout>
				<GovSkeleton
					width="190px"
					height="40px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</ButtonGroupLayout>
		</ContentLayout>
	);
};
